export default __webpack_public_path__ + "static/media/icon-menu-question.1df08a31.svg";